import pipe from 'lodash/fp/pipe'
import * as Redux from 'redux'
import * as Actions from './actions'
import * as Constants from './constants'
import * as Utils from './utils'

type IsLoading = boolean
export interface State<Data = any> {
  data?: Data,
  isLoading: IsLoading,
  isOpen: boolean,
}
export const initialState: State = {
  data: null,
  isLoading: false,
  isOpen: false,
}

export const reducer = (constants: {[key: string]: string}) =>
(state = initialState, action: Actions.DetailPanelAction<IsLoading>) => {
  switch (action.type) {
    case constants[Constants.TOGGLE]:
      return {
        ...state,
        data: state.isOpen ? action.value || state.data : null,
        isOpen: !state.isOpen,
      }
    case constants[Constants.OPEN]:
      return {
        ...state,
        data: action.value || state.data,
        isOpen: true,
      }
    case constants[Constants.CLOSE]:
      return {
        ...state,
        isOpen: false,
      }
    case constants[Constants.LOAD]:
      return {
        ...state,
        isLoading: action.value,
      }
    default:
      return state
  }
}

type CreateReducer = (prefix: string) => Redux.Reducer<State>
export const createReducer: CreateReducer = pipe(
  Utils.createConstantsMap,
  reducer,
)



// WEBPACK FOOTER //
// ./src/components/detail-panel/reducer.ts